import React, { useEffect, useState } from 'react'
import Input from '../../Common/ui/input'
import SelectInput from '../../Common/ui/selectInput'
import { useOnboardingStoreForSurvey, useProfileScreenStore } from '../../Containers/Onboarding/Store/OnboardingStore'
import { Avatar, Box, IconButton, Tab, Tooltip } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Checkbox } from 'src/Common/ui/checkbox'
import AddSquareIcon from 'src/Common/Icon/AddSquareIcon'
import { RxTrash } from 'react-icons/rx'
import { cn, validateAndProcessImage } from 'src/lib/utils'
import * as EndPoints from '../../Entities/EndPoints'
import CustomSelect from '../../Common/ui/CustomSelect'
import { toast } from 'react-toastify'
import Axios from 'src/Axios'
import DatePickerInput from 'src/Common/ui/DatePickerInput'
import { t } from 'i18next'
import { ORG_LOGO_KEY } from 'src/Entities/OnBoardingContainerTypes'

const ProfileScreen = ({ control, register, errors, setError, clearErrors, profileData, setProfileData, curencyCode, heatMap, reset, isDisabled }) => {
    const orgId = localStorage.getItem('orgId')
    const [ cityStateCountry, setCityStateCountry ] = useState({ stateId: '', countryId: '', cityId: '' })
    const [ orgTypesData, setOrgTypesData ] = useState([])
    const [ country, setCountry ] = useState([])
    // const [ state, setState ] = useState([])
    // const [ city, setCity ] = useState([])
    const [ stateArrayData, setStateArrayData ] = useState([])
    const [ cityArrayData, setCityArrayData ] = useState([])
    const [ tabValue, setTabValue ] = useState(0)
    const orgAddressLastIndex = Object.values(profileData?.orgAddress?.length > 0 && profileData?.orgAddress[profileData?.orgAddress?.length - 1])?.some(value => value === '' || value === null || value === undefined)
    const { orgTypeData, getOrgType } = useOnboardingStoreForSurvey()
    // const { getCompanyProfile, getCountry, getCountryData, getState, getStateData, getCity, getCityData } = useProfileScreenStore()
    const { getCompanyProfile, getCountry, getCountryData, getState, getCity } = useProfileScreenStore()
    const isAnyRegistered = profileData?.orgAddress?.some(item => item.isRegisteredAddress)

    const handleAddTab = () => {
        setProfileData((profileData) => {
            const newTab = {
                tabName: `Branch Office(s)${profileData?.orgAddress?.length}`,
                orgId,
                street: '',
                countryId: '',
                stateId: '',
                cityId: '',
                pincode: null,
                addressTypeId: 2,
                isRegisteredAddress: false,
                status: 1,
                addressId: 0
            }
            const updatedOrgAddress = [ ...profileData.orgAddress, newTab ]
            setTabValue(updatedOrgAddress.length - 1)
            return {
                ...profileData,
                orgAddress: updatedOrgAddress
            }
        })
    }
    const instance = Axios.getInstance()
    useEffect(() => {
        instance.get(EndPoints.API_ENDPOINT + `/survey/GetOrganizationById?orgId=${orgId}`)
            .then((res) => {
                const currencyCodeVale = curencyCode.find(cc => cc.name === res?.data?.currencyCode)?.id

                const updatedOrgAddress = res?.data?.orgAddress?.map((mapDt, mapIdx) => ({
                    addressId: mapDt?.id,
                    tabName: mapDt?.addressTypeId === 1 ? 'Head/Corporate Office' : `Branch Office(s)${mapIdx > 1 ? mapIdx : mapIdx === 1 ? '' : ''}`,
                    orgId,
                    street: mapDt?.street,
                    countryId: mapDt?.countryId,
                    stateId: mapDt?.stateId,
                    cityId: mapDt?.cityId,
                    pincode: mapDt?.pincode,
                    addressTypeId: mapDt?.addressTypeId,
                    isRegisteredAddress: mapDt?.isRegisteredAddress,
                    status: mapDt?.status
                })) || []

                const hasBranchOffice = updatedOrgAddress.some(addr => addr.addressTypeId === 2)
                if (!hasBranchOffice) {
                    updatedOrgAddress.push({
                        tabName: 'Branch Office(s)',
                        orgId,
                        street: '',
                        countryId: '',
                        stateId: '',
                        cityId: '',
                        pincode: null,
                        addressTypeId: 2,
                        isRegisteredAddress: false,
                        status: 1,
                        addressId: 0
                    })
                }

                const userRequests = {
                    id: res?.data?.id,
                    name: res?.data?.name,
                    [ORG_LOGO_KEY]: res?.data?.[ORG_LOGO_KEY],
                    organizationTypeId: res?.data?.organizationTypeId,
                    industry: res?.data?.industry,
                    inagurationDate: res?.data?.inagurationDate,
                    currencyCode: currencyCodeVale,
                    currencyName: res?.data?.currencyName,
                    heatmap: res?.data?.heatmap,
                    status: res?.data?.status,
                    financialYearId: res?.data?.financialYearId,
                    financialYear: res?.data?.financialYear,
                    orgAddress: updatedOrgAddress
                }
                setProfileData(userRequests)
            })
            .catch((err) => console.warn(err))
    }, [orgId])

    useEffect(() => {
        getCountry()
    }, [])

    const handleRemoveTab = (idx) => {
        setProfileData((profileData) => {
            const updatedOrgAddress = profileData?.orgAddress?.filter((_, filterIdx) => filterIdx !== idx)

            setTabValue((prevTabValue) => {
                if (prevTabValue === idx) { return idx > 0 ? idx - 1 : 0 }
                if (prevTabValue > idx) { return prevTabValue - 1 }
                return prevTabValue
            })
            return {
                ...profileData,
                orgAddress: updatedOrgAddress
            }
        })
    }

    const handleChange = (event, newValue) => {
        const currentTabErrors = errors
        if (currentTabErrors && Object.keys(currentTabErrors).length > 0) {
            toast.warning('Resolve errors before switching tabs.')
            return
        }
        setTabValue(newValue)
    }

    const handleSelectFieldChange = (value, name) => {
        if ([ 'organizationTypeId', 'heatmapId', 'currencyCode', 'dateFormat' ].includes(name)) {
            setProfileData((prevData) => ({
                ...prevData,
                [name]: Number(value)
            }))
        } else {
            setProfileData((prevData) => ({
                ...prevData,
                [name]: value
            }))
        }
    }

    const handleAddFieldsChange = (value, field, idx) => {
        const baseField = field.split('_')[0]

        if ([ 'countryId', 'stateId', 'cityId' ].includes(baseField)) {
            setProfileData((prevData) => ({
                ...prevData,
                orgAddress: prevData?.orgAddress?.map((mapDt, mapIdx) =>
                    mapIdx === idx
                        ? {
                            ...mapDt,
                            [baseField]: value ? Number(value) : '',
                            ...(baseField === 'countryId' ? { stateId: '', cityId: '' } : {}),
                            ...(baseField === 'stateId' ? { cityId: '' } : {})
                        }
                        : mapDt
                )
            }))
            setCityStateCountry((prevState) => ({
                ...prevState,
                [baseField]: value ? Number(value) : '',
                ...(baseField === 'countryId' ? { stateId: '', cityId: '' } : {})
            }))
            return
        }

        if ([ 'street', 'pincode', 'isRegisteredAddress' ].includes(baseField)) {
            setProfileData((prevData) => ({
                ...prevData,
                orgAddress: prevData?.orgAddress?.map((mapDt, mapIdx) =>
                    mapIdx === idx ? { ...mapDt, [baseField]: value } : mapDt
                )
            }))
            return
        }

        if ([ 'name', 'industry' ].includes(field)) {
            setProfileData((prevData) => ({
                ...prevData,
                [field]: value
            }))
        }
    }

    useEffect(() => {
        const fetchCompanyProfile = async () => {
            await getCompanyProfile(orgId)
        }
        if (cityStateCountry?.stateId) {
            getCity(cityStateCountry?.stateId)
        }
        if (cityStateCountry?.countryId) {
            getState(cityStateCountry?.countryId)
        }

        getOrgType(orgId || 0)
        if (orgId) {
            fetchCompanyProfile()
        }
    }, [ orgId, cityStateCountry?.countryId, cityStateCountry?.stateId ])

    useEffect(() => {
        if (orgTypeData?.length > 0) {
            setOrgTypesData(orgTypeData)
        }
        if (getCountryData?.length > 0) {
            setCountry(getCountryData)
        }
        // if (getStateData?.length > 0) {
        //     setState(getStateData)
        // }
        // if (getCityData?.length > 0) {
        //     setCity(getCityData)
        // }
    // }, [ orgTypeData?.length, getCountryData?.length, getCityData?.length, getStateData?.length ])
    }, [ orgTypeData?.length, getCountryData?.length ])

    const resetErrorsForProfileFields = (profileData) => {
        const initialValues = {}

        if (profileData?.orgAddress && Array.isArray(profileData.orgAddress)) {
            profileData.orgAddress.forEach((data, index) => {
                Object.entries(data).forEach(([ key, value ]) => {
                    const fieldName = `${key}_${index}`
                    initialValues[fieldName] = value
                })
            })
        }
        Object.entries(profileData).forEach(([ key, value ]) => {
            if (key !== 'orgAddress') {
                initialValues[key] = value
            }
        })

        return initialValues
    }

    useEffect(() => {
        const initialValues = resetErrorsForProfileFields(profileData)
        reset(initialValues)
    }, [profileData])
    useEffect(() => {
        if (profileData?.orgAddress?.length > 0) {
            const fetchStates = async () => {
                const allStates = await Promise.all(
                    profileData.orgAddress.map(async (mapDt) => {
                        try {
                            const response = await instance.get(
                            `${EndPoints.API_ENDPOINT}/masterController/states?id=${mapDt?.countryId}`
                            )
                            return response?.data || []
                        } catch (error) {
                            console.error('Error fetching states:', error)
                            return []
                        }
                    })
                )
                setStateArrayData(allStates)
            }
            const fetchCitys = async () => {
                const allCitys = await Promise.all(
                    profileData.orgAddress.map(async (mapDt) => {
                        try {
                            const response = await instance.get(
                            `${EndPoints.API_ENDPOINT}/masterController/cities?id=${mapDt?.stateId}`
                            )
                            return response?.data || []
                        } catch (error) {
                            console.error('Error fetching cities:', error)
                            return []
                        }
                    })
                )
                setCityArrayData(allCitys)
            }

            fetchStates()
            fetchCitys()
        }
    }, [profileData?.orgAddress])
    const handleImageChange = (e) => {
        const file = e.target.files[0]
        validateAndProcessImage(file, setSelectedImage, setProfileData, t, toast, ORG_LOGO_KEY)
        e.target.value = ''
    }

    const handleRemoveImage = () => {
        setSelectedImage(null)
        setProfileData((prevNode) => ({
            ...prevNode,
            [ORG_LOGO_KEY]: ''
        }))
    }
    // eslint-disable-next-line no-unused-vars
    const [ selectedImage, setSelectedImage ] = useState('')
    return (
        <form style={{ pointerEvents: isDisabled && 'none', opacity: isDisabled && '0.5' }} >
            {/* <h2 className='onboarding-content-title'>Organization Profile</h2> */}
            <div className="grid grid-cols-3 gap-4 mt-4 mb-6">

                <div style={{ width: '100%' }}>
                    <Input required errors={errors} control={control} name="name" label="Organization Name" register={register} placeholder="Enter Organization Name" type="text"
                        onValueChange={(e) => { handleAddFieldsChange(e?.target?.value, 'name') }}
                        value={profileData?.name}
                        rules={{
                            required: 'Organization Name is required',
                            validate: (value) => {
                                if (!/^[a-zA-Z0-9\s]+$/.test(value)) {
                                    return 'Organization Name must not contain special characters'
                                }
                                if (value.length > 50) {
                                    return 'Organization Name must not exceed 50 characters'
                                }
                                return true
                            }
                        }}
                        setError={setError} clearErrors={clearErrors}
                    />
                </div>
                <div style={{ width: '100%' }}>
                    <div className="col-span-1" style={{ width: '100%' }}>
                        <CustomSelect
                            name="organizationTypeId"
                            label="Organization Type"
                            options={orgTypesData}
                            value={profileData?.organizationTypeId}
                            onValueChange={handleSelectFieldChange}
                            placeholder='Select Organization Type'
                            errors={errors}
                            control={control}
                            rules={{ required: 'Organization Type is required' }}
                            required
                        />
                    </div>
                </div>
                <div style={{ width: '100%' }}>
                    <Input
                        required errors={errors} control={control} name="industry" label="Industry" register={register} placeholder="Enter Industry" type="text"
                        rules={{
                            required: 'Industry is required',
                            validate: (value) => {
                                if (!/^[a-zA-Z0-9\s]+$/.test(value)) {
                                    return 'Industry must not contain special characters'
                                }
                                if (value.length > 30) {
                                    return 'Industry must not exceed 30 characters'
                                }
                                return true
                            }
                        }}
                        setError={setError} clearErrors={clearErrors}
                        value={profileData?.industry}
                        onValueChange={(e) => { handleAddFieldsChange(e?.target?.value, 'industry') }}
                    />
                </div>
                <div style={{ width: '100%' }}>
                    <DatePickerInput
                        errors={errors}
                        control={control}
                        // resetTrigger={resetTrigger}
                        required
                        rules={{ required: 'Inaguration date is required' }}
                        name='inagurationDate'
                        label={'Inaguration Date'}
                        register={register}
                        type="text"
                        value={profileData?.inagurationDate || ''}
                        onValueChange={handleSelectFieldChange}
                        maxDate={new Date()}
                        // disabled={loading}
                    />
                    {/* <SelectInput
                        required errors={errors} control={control} name="dateFormat" label="Inauguration Date" register={register} placeholder="Select Date Format"
                        rules={{
                            required: 'Date Format is required'
                        }}
                        value={profileData?.dateFormat}
                        onValueChange={handleSelectFieldChange}
                        options={dateFormat.map(type => ({ value: type.id, label: type.name }))}
                    /> */}
                </div>
                {!isDisabled && <div style={{ width: '100%' }}>
                    <SelectInput
                        required errors={errors} control={control} name="currencyCode" label="Currency Code" register={register} placeholder="Select Currency Code"
                        rules={{
                            required: 'Currency Code is required'
                        }}
                        value={profileData?.currencyCode}
                        onValueChange={handleSelectFieldChange}
                        options={curencyCode.map(type => ({ value: type.id, label: type.name }))}
                    />
                </div>}
                <div>
                    <div className="grc-label block mb-3">Organization Logo</div>
                    <div className="flex w-full">
                        {profileData?.[ORG_LOGO_KEY]?.file
                            ? <img
                                className="w-14 h-14 rounded-full object-cover border-2 border-white shadow-md hover:scale-105 transition-transform duration-300"
                                src={`data:${profileData?.[ORG_LOGO_KEY]?.contentType};base64, ${profileData?.[ORG_LOGO_KEY]?.file}`}
                                alt="Profile Icon"
                            />
                            : <Avatar sx={{ width: 40, height: 40 }} src={profileData?.[ORG_LOGO_KEY]} alt={profileData?.name} />
                        }

                        <div className='space-x-4'>
                            <div className='flex px-4 gap-4 mb-1 mt-[7px]'>
                                <label className={`flex cursor-pointer ${profileData?.[ORG_LOGO_KEY]?.file ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                    <input type="file" accept="image/png, image/jpeg, image/jpg, image/webp" style={{ display: 'none' }} onChange={handleImageChange} disabled={!!profileData?.[ORG_LOGO_KEY]?.file} />
                                    <img src={'/Common/Icon/ArrowUploadIcon.svg'} width={'20px'} alt="Upload icon" />
                                    <span className='mt-2 ml-2 grc-label-one !text-[1rem]'>{'Upload'}</span>
                                </label>
                                {profileData?.[ORG_LOGO_KEY]?.file && <div
                                    className={`flex cursor-pointer ml-5 ${!profileData?.[ORG_LOGO_KEY]?.file ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    onClick={profileData?.[ORG_LOGO_KEY]?.file ? handleRemoveImage : null}
                                >
                                    <img src={'/Common/Icon/DeleteIcon.svg'} width='20px' alt="Remove icon" />
                                    <span className='mt-[5px] ml-2 grc-label-one !text-[1rem]'>{'Remove'}</span>
                                </div>}
                            </div>
                            {/* <div className='mt-2 grc-label-one !text-[1rem]'>{'Image size should not exceed 2MB'}</div> */}
                        </div>
                    </div>
                </div>
                {/* <div style={{ width: '100%' }}>
                    <SelectInput
                        required errors={errors} control={control} name="heatmapId" label="Heat Map" register={register} placeholder="Select Heat Map"
                        rules={{
                            required: 'Heat Map is required'
                        }}
                        value={profileData?.heatmapId}
                        onValueChange={handleSelectFieldChange}
                        options={heatMap.map(type => ({ value: type.id, label: type.name }))}
                    />
                </div> */}
            </div>
            {/* <h3 className='onboarding-content-title onboarding-content-title-muted  '>Address</h3> */}
            <Box sx={{ width: '100%', typography: 'body1' }}>
                <TabContext style={{ width: '100%' }} value={tabValue} >
                    <Box sx={{ width: '100%', overflowX: 'auto' }}>
                        <TabList sx={{
                            width: 'max-content',
                            display: 'flex',
                            overflowX: 'auto',
                            marginTop: '0px',
                            pointerEvents: 'auto',
                            '& .MuiTab-root': {
                                color: 'hsl(var(--muted))',
                                padding: '0px',
                                fontSize: '14px',
                                minHeight: '30px',
                                paddingRight: '12px',
                                '&.Mui-selected': {
                                    color: 'hsl(var(--primary))',
                                    minHeight: '30px'
                                }
                            },
                            '& .MuiTabs-indicator': {
                                backgroundColor: 'hsl(var(--primary))',
                                marginBottom: '10px'
                                // width: '131.875px'
                            }
                        }} onChange={(e, newValue) => handleChange(e, newValue)} aria-label="lab API tabs example">
                            {profileData?.orgAddress?.map((mapDt, mapIdx) => {
                                return <Tab sx={{ textTransform: 'capitalize' }}key={mapIdx} label={
                                    <div>
                                        <span className='mr-2'>{mapDt?.tabName}</span>
                                        <span>
                                            {!(mapIdx === 0 || mapIdx === 1) && <Tooltip title="Delete Branch Office" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                <IconButton
                                                    onClick={() => {
                                                        handleRemoveTab(mapIdx)
                                                    }} sx={{ padding: 0 }}>
                                                    <RxTrash className='text-danger' />
                                                </IconButton>
                                            </Tooltip>}
                                        </span>
                                        <span>
                                            {profileData?.orgAddress?.length - 1 === mapIdx && <Tooltip title="Add Branch Office" placement="right-start" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                <span>
                                                    <IconButton
                                                        className={cn(orgAddressLastIndex ? 'opacity-50' : 'opacity-100 cursor-pointer')}
                                                        disabled={orgAddressLastIndex}
                                                        onClick={() => {
                                                            handleAddTab()
                                                        }} sx={{ padding: 0.3 }}>
                                                        <AddSquareIcon />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>}
                                        </span>
                                    </div>
                                } value={mapIdx}/>
                            })}
                        </TabList>
                    </Box>
                    {profileData?.orgAddress?.map((mapDt, mapIdx) => {
                        return <TabPanel sx={{ padding: '0px' }} key={mapIdx} value={mapIdx}>{
                            <>
                                <div className="grid grid-cols-3 gap-4 mt-4">
                                    <div className="col-span-1" style={{ width: '100%' }}>
                                        <Input
                                            // name="street"
                                            name={`street_${mapIdx}`} type="text" placeholder="Enter apartment/house/street" label="Apartment/House/Street" value={mapDt?.street || ''} onValueChange={(e) => { handleAddFieldsChange(e.target.value, 'street', mapIdx) }} control={control} errors={errors}
                                            required rules={{
                                                validate: (value) => {
                                                    if (value) {
                                                        const address = value.trim()
                                                        if (!value.trim()) { return 'Address cannot be empty spaces' }
                                                        if (address.length > 50) { return 'Address must not exceed 50 characters' }
                                                        return true
                                                    } else if (!value) {
                                                        return 'Address is required'
                                                    }
                                                    return true
                                                }
                                            }}
                                            setError={setError} clearErrors={clearErrors}
                                        />
                                    </div>
                                    <div className="col-span-1" style={{ width: '100%' }}>
                                        <CustomSelect
                                            name={`countryId_${mapIdx}`}
                                            label="Country"
                                            options={country}
                                            value={mapDt?.countryId || ''}
                                            onValueChange={handleAddFieldsChange}
                                            placeholder='Select Country'
                                            mapIdx={mapIdx}
                                            errors={errors}
                                            control={control}
                                            required
                                            rules={{ required: 'Country is required' }}
                                        />
                                    </div>
                                    <div style={{ width: '100%' }}>
                                        <div style={{ width: '100%' }}>
                                            <CustomSelect
                                                name={`stateId_${mapIdx}`}
                                                label="State"
                                                options={Array.isArray(stateArrayData[mapIdx]) ? stateArrayData[mapIdx] : []}
                                                value={mapDt?.stateId || ''}
                                                onValueChange={handleAddFieldsChange}
                                                placeholder='Select State'
                                                mapIdx={mapIdx}
                                                errors={errors}
                                                control={control}
                                                required
                                                rules={{ required: 'State is required' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-3 gap-4 mt-4">
                                    <div className="col-span-1" style={{ width: '100%' }}>
                                        <CustomSelect
                                            name={`cityId_${mapIdx}`}
                                            label="City"
                                            options={Array.isArray(cityArrayData[mapIdx]) ? cityArrayData[mapIdx] : []}
                                            value={mapDt?.cityId || ''}
                                            onValueChange={handleAddFieldsChange}
                                            placeholder='Select City'
                                            mapIdx={mapIdx}
                                            errors={errors}
                                            control={control}
                                            required
                                            rules={{ required: 'City is required' }}
                                        />
                                    </div>
                                    <div style={{ width: '100%' }}>
                                        <Input
                                            placeholder="Enter Pincode" type="number" label="Pincode" name={`pincode_${mapIdx}`} required
                                            value={mapDt?.pincode} errors={errors} control={control} onValueChange={(e) => { handleAddFieldsChange(e.target.value, 'pincode', mapIdx) }}
                                            rules={{
                                                required: 'Pincode is required',
                                                validate: (value) => {
                                                    if (!/^\d{6}$/.test(value)) {
                                                        return 'Pincode must be exactly 6 digits'
                                                    }
                                                }
                                            }}
                                            setError={setError} clearErrors={clearErrors} register={register}
                                        />
                                    </div>
                                    <div style={{ width: '100%' }}>
                                        <div className='justify-center h-[100%] flex flex-col'>
                                            <div className='flex h-[100%] mt-12 flex-row items-center' style={{ display: isAnyRegistered && !mapDt?.isRegisteredAddress ? 'none' : 'flex' }}>
                                                <Checkbox checked={mapDt?.isRegisteredAddress} onCheckedChange={(e) => { handleAddFieldsChange(e, 'isRegisteredAddress', mapIdx) }} className='my-auto' />
                                                <label className='grc-label ml-2'>Registered Address</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }</TabPanel>
                    })}
                </TabContext>
            </Box>
        </form>
    )
}

export default ProfileScreen
